import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import EditMfrLiquidForm from '../components/EditMfrLiquidForm';

const EditMfrLiquidPage = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const handleSuccess = () => {
    history.push('/admin/manufacturer_management?activeTab=3');
  };

  return id ? <EditMfrLiquidForm id={id} onSuccess={handleSuccess} /> : null;
};

export default EditMfrLiquidPage;